import { initialize, LDClient } from "launchdarkly-js-client-sdk";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import React__default, * as React from "react";
export type LaunchDarklyConfig = {
  clientSideId: string;
  isDev: boolean;
};

export type WithLDProvider = ({ children }: { children: React.ReactNode }) => React__default.JSX.Element;

export async function initializeLaunchDarkly(ldClient: LDClient, clientSideID: string): Promise<WithLDProvider> {
  return await asyncWithLDProvider({ ldClient, clientSideID, timeout: 5 });
}

export function createLDClient(clientSideID: string): LDClient {
  return initialize(clientSideID, { anonymous: true });
}
